import { useRouter } from '@tanstack/react-router'
import { useCallback } from 'react'

import { useInvalidateShipmentOrdersSummary } from './use-invalidate-shipment-orders-summary'

/**
 * 配送依頼一覧を再取得する（#5285 2.1）。
 * 一覧は router の loader が持つので router.invalidate() で取り直し、
 * 検索結果サマリーは react-query 側なので summaryAll を invalidate する。
 * 片方だけだと、一括操作の後に一覧とサマリーの数字がずれたままになる。
 *
 * サマリーの取り直しは待たない。待つと、一括操作のあとの選択解除・モーダルを閉じる・
 * トーストが、集計（最も重いクエリ）の完了まで止まる。一覧の取り直しと並行して走らせ、
 * 戻り値は一覧の取り直しが終わった時点で解決する
 */
export const useRefreshShipmentOrders = (tenantKey: string) => {
  const router = useRouter()
  const invalidateSummary = useInvalidateShipmentOrdersSummary(tenantKey)
  return useCallback(async () => {
    void invalidateSummary()
    await router.invalidate()
  }, [router, invalidateSummary])
}
